import { useEffect, useState } from "react";
import { baseUrl } from "../utils/apiActions/dashboardApi";
import { useParams } from "react-router-dom";
import moment from "moment";
import { formatNumber } from "../utils/data/essential";
import PaymentReceipt from "./PaymentReceipt";
import useAxios from "../hooks/useAxios";
const ReceiptVerification = () => {
  const [receiptData, setReceiptData] = useState();
  const [subscriber, setSubscriber] = useState();
  const [location, setLocation] = useState([]);
  const [accountData, setAccountData] = useState();
  const [loading, setLoading] = useState(true);
  const { tid } = useParams();
  const axiosInstance = useAxios();
  useEffect(async () => {
    const res = await axiosInstance.get(`/payments/collections?transactionId=${tid}`);
    console.log("Verification data:", res);
    setReceiptData(res.data[0]);
    setLoading(false);
  }, []);
  useEffect(async () => {
    if (receiptData) {
      const transactionData = receiptData;
      const { accountId } = transactionData;
      const response = await axiosInstance.get(`/accounts/${accountId}`);
      setAccountData(response.data);

      const { subscriberId } = accountData;
      const subscriberResponse = await axiosInstance.get(
        `/subscribers/${subscriberId}`
      );
      setSubscriber(subscriberResponse.data);
      // Fetch location data
      const { locationId } = accountData;
      if (locationId) {
        const locationResponse = await axiosInstance.get(
          `/locations/${locationId}/details`
        );
        setLocation(locationResponse.data);
      }
    }
  }, [receiptData]);
  if (loading)
    return (
      <div
        className='d-flex justify-content-center'
        style={{ marginTop: "15%" }}
      >
        <h5>Loading...</h5>
      </div>
    );
  return (
    <div style={{ backgroundColor: "#d4d4d7", padding: 10 }}>
      <div className='card mt-2 mb-2 receipt-container'>
        <div className='ml-5 mt-2'>
          <p style={{ fontSize: 22, fontWeight: 500, color: "#000" }}>
            REPUBLIC OF RWANDA
          </p>
          <p style={{ fontSize: 17, fontWeight: 300, color: "#000" }}>
            CITY OF KIGALI
          </p>
          <img
            src='/LOGO_COK.jpg'
            alt='kigali city logo'
            width={100}
            height={100}
          />
          <div className='d-flex justify-content-between flex-wrap'>
            <div className='mt-3'>
              <table>
                <tbody>
                  <tr>
                    <td colSpan={2} style={{ fontWeight: 500, fontSize: 17 }}>
                      DISTRICT:
                    </td>
                    <td></td>
                    <td style={{ fontSize: 14 }}>{location[1]?.name}</td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ fontWeight: 500, fontSize: 17 }}>
                      SECTOR:
                    </td>
                    <td></td>
                    <td style={{ fontSize: 14 }}>{location[2]?.name}</td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ fontWeight: 500, fontSize: 17 }}>
                      CELL:
                    </td>
                    <td></td>
                    <td style={{ fontSize: 14 }}>{location[3]?.name}</td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ fontWeight: 500, fontSize: 17 }}>
                      VILLAGE:
                    </td>
                    <td></td>
                    <td style={{ fontSize: 14 }}>{location[4]?.name}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className='mt-3 mr-2'>
              <table>
                <tbody>
                  <tr>
                    <td colSpan={2} style={{ fontWeight: 500, fontSize: 17 }}>
                      RECEIPT NO:
                    </td>
                    <td></td>
                    <td style={{ fontSize: 14 }}>
                      {receiptData?.transactionId}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ fontWeight: 500, fontSize: 17 }}>
                      DATE:
                    </td>
                    <td></td>
                    <td style={{ fontSize: 14 }}>
                      {moment(receiptData?.datetime).format("DD-MM-YYYY")}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ fontWeight: 500, fontSize: 17 }}>
                      FEE PAYER:
                    </td>
                    <td></td>
                    <td style={{ fontSize: 14 }}>{accountData?.accountName}</td>
                  </tr>
                  <tr>
                    <td colSpan={2} style={{ fontWeight: 500, fontSize: 17 }}>
                      PHONE NO:
                    </td>
                    <td></td>
                    <td style={{ fontSize: 14 }}>
                      {"+" + accountData?.accountNumber}
                    </td>
                  </tr>
                  {subscriber?.tin && (
                    <tr>
                      <td colSpan={2} style={{ fontWeight: 500, fontSize: 17 }}>
                        TIN NO:
                      </td>
                      <td></td>
                      <td style={{ fontSize: 14 }}>{subscriber?.tin}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className='d-flex justify-content-center mt-4'>
            <p style={{ fontSize: 22, fontWeight: 500, color: "#000" }}>
              PAYMENT RECEIPT
            </p>
          </div>
          <div className='mr-5'>
            <table style={{ width: "100%" }}>
              <thead style={{ backgroundColor: "#124db1", height: 40 }}>
                <th className='pl-2' style={{ color: "#FFF", fontSize: 17 }}>
                  Service
                </th>
                <td style={{ color: "#FFF", fontSize: 17 }}>Amount</td>
              </thead>
              <tr style={{ backgroundColor: "#f5f5f5", height: 40 }}>
                <td className='pl-2' style={{ color: "#616161", fontSize: 17 }}>
                  Security Fee
                </td>
                <td style={{ color: "#616161", fontSize: 17 }}>
                  {formatNumber(receiptData?.amount) + " RWF"}
                </td>
              </tr>
              <tbody>
                <tr style={{ backgroundColor: "#FFF", height: 40 }}>
                  <td
                    className='pl-2'
                    style={{ color: "#616161", fontSize: 17 }}
                  >
                    Total
                  </td>
                  <td style={{ color: "#000", fontSize: 17 }}>
                    {formatNumber(receiptData?.amount) + " RWF"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* Help line section */}
          <div className='mr-5 mt-3' style={{ border: "1.5px solid" }}>
            <div className='d-flex justify-content-center mt-2'>
              <p style={{ fontSize: 22, fontWeight: 500, color: "#000" }}>
                HELP LINE
              </p>
            </div>
            <div className='ml-3 '>
              <p style={{ fontSize: 18, fontWeight: 500, color: "#002033" }}>
                Call center: 0788122922
              </p>
              <p style={{ fontSize: 18, fontWeight: 500, color: "#002033" }}>
                Whatsapp: 0798113341
              </p>
            </div>
          </div>
        </div>
        <div className='d-flex justify-content-center mt-2'>
          {receiptData?.accountId && (
            <PaymentReceipt
              address={[
                { name: "Kigali" },
                { name: receiptData?.district },
                { name: receiptData?.sector },
                { name: receiptData?.cell },
                { name: receiptData?.village },
              ]}
              date={receiptData?.datetime}
              accountId={receiptData?.accountId}
              amount={receiptData?.amount}
              tid={receiptData?.transactionId}
              language={{ english: true }}
              onHide={() => false}
              title='Generate payment receipt'
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ReceiptVerification;
